import { defineRouting } from 'next-intl/routing';

export const locales = ['en', 'fr'] as const;
export const defaultLocale = 'fr' as const;

export const routing = defineRouting({
  locales: locales,
  defaultLocale: defaultLocale,
  localePrefix: 'always' // Always show locale prefix in URL, including default locale
});
